<template>
  <div class="background"></div>
  <router-view id="content" />
</template>

